import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { CHILDREN_PROPTYPES } from 'base/constants/propTypes';

const styles = theme => ({
  root: {
    paddingBottom: 0,
    paddingTop: theme.spacing(1),
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    marginTop: 8,
    maxHeight: 150,
    overflow: 'auto'
  }
});

const SuggestionPaper = ({ children, classes }) => (
  <Paper classes={classes}>{children}</Paper>
);

SuggestionPaper.propTypes = {
  children: CHILDREN_PROPTYPES,
  classes: PropTypes.shape({})
};

export default withStyles(styles)(SuggestionPaper);
